/**
 * Capa de Lógica de Negocio (Business Logic - BL) para la dinámica "Light Show Pro".
 * Gestiona validaciones estructurales y formatea las respuestas para el componente visual del Admin.
 */

import { 
    Prepare as DLPrepare, 
    Start as DLStart, 
    Stop as DLStop, 
    GetAllPresets as DLGetAllPresets, 
    CreatePreset as DLCreatePreset, 
    UpdatePreset as DLUpdatePreset, 
    DeletePreset as DLDeletePreset,
    GetLightShowStats as DLGetLightShowStats,
    GetSettings as DLGetSettings,
    SaveSettings as DLSaveSettings,
    ApplySettings as DLApplySettings
} from './../../../DL/Admin/Games/LightShow'

const Prepare = async (beatsPerMinute, framesSequence, targetZones = null, presetName = null, flashActive = true, screenActive = true, offColor = '#000000') => {
    try {
        if (!beatsPerMinute || beatsPerMinute <= 0) {
            return { success: false, message: "El ritmo (BPM) debe ser mayor a cero." }
        }

        if (!framesSequence || !Array.isArray(framesSequence)) {
            return { success: false, message: "La secuencia de animación es inválida o no existe." }
        }

        if (framesSequence.length < 1) {
            return { success: false, message: "Debes configurar al menos 1 frame." }
        }

        const response = await DLPrepare(beatsPerMinute, framesSequence, targetZones, presetName, flashActive, screenActive, offColor)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: "Excepción en la lógica de negocio al preparar los frames del show." }
    }
}

const Start = async (beatsPerMinute, framesSequence, targetZones = null, presetName = null, flashActive = true, screenActive = true, offColor = '#000000') => {
    try {
        if (!beatsPerMinute || beatsPerMinute <= 0) return { success: false, message: "Ritmo inválido." };
        if (!framesSequence || framesSequence.length < 1) return { success: false, message: "Faltan frames." };

        const response = await DLStart(beatsPerMinute, framesSequence, targetZones, presetName, flashActive, screenActive, offColor);

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: "Excepción en la lógica de negocio al intentar iniciar." }
    }
}

const Stop = async (targetZones = null) => {
    try {
        const response = await DLStop(targetZones)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: "Excepción en la lógica de negocio al intentar detener el show." }
    }
}

const GetAllPresets = async () => {
    return await DLGetAllPresets();
}

const CreatePreset = async (name, bpm, framesSequence) => {
    if (!name || name.trim() === '') return { success: false, message: "El nombre del preset es obligatorio." };
    if (!bpm || bpm <= 0) return { success: false, message: "El ritmo (BPM) debe ser mayor a cero." };
    if (!framesSequence || framesSequence.length < 1) return { success: false, message: "Debes tener al menos 1 frame." };
    
    return await DLCreatePreset(name, bpm, framesSequence);
}

const UpdatePreset = async (id, name, bpm, framesSequence) => {
    if (!id || id <= 0) return { success: false, message: "Preset inválido." };
    if (!name || name.trim() === '') return { success: false, message: "El nombre es obligatorio." };
    if (!bpm || bpm <= 0) return { success: false, message: "El ritmo (BPM) debe ser mayor a cero." };
    if (!framesSequence || framesSequence.length < 1) return { success: false, message: "Debes tener al menos 1 frame." };

    return await DLUpdatePreset(id, name, bpm, framesSequence);
}

const DeletePreset = async (id) => {
    if (!id || id <= 0) return { success: false, message: "Preset inválido." };
    return await DLDeletePreset(id);
}

const GetLightShowStats = async () => {
    return await DLGetLightShowStats();
}

const GetSettings = async () => {
    return await DLGetSettings();
}

const SaveSettings = async (settings) => {
    return await DLSaveSettings(settings);
}

const ApplySettings = async (settings) => {
    return await DLApplySettings(settings);
}

export { Prepare, Start, Stop, GetAllPresets, CreatePreset, UpdatePreset, DeletePreset, GetLightShowStats, GetSettings, SaveSettings, ApplySettings };